import React from 'react';

const Female: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 100 100" {...props}>
    <path
      fill="currentColor"
      d="M49.548 53.068c-6.638 0-11.93-5.233-11.93-11.703 0-3.129 1.257-6.13 3.494-8.342a11.998 11.998 0 018.436-3.456c3.164 0 6.199 1.243 8.436 3.456a11.732 11.732 0 013.494 8.342c0 6.47-5.388 11.703-11.93 11.703zm-2.309 4.377v7.04h-5.003v4.567h5.003V74h4.618v-4.948h5.003v-4.567h-5.003v-7.04C59.843 56.398 66 49.548 66 41.365 66 32.326 58.592 25 49.548 25a16.643 16.643 0 00-11.701 4.793A16.274 16.274 0 0033 41.365c0 8.183 6.157 15.033 14.24 16.08z"
    ></path>
    <circle cx="50" cy="50" r="47.5" stroke="currentColor" strokeWidth="5"></circle>
  </svg>
);

export default Female;
